import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { LoginNavbar } from '../../components/layout/Navbar';
import { useTranslation } from 'react-i18next';

const Footer = ({ className, children }) => (
  <footer className={className || 'footer'}>
    {children}
  </footer>
);

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <LoginNavbar />
      <div className="home-container">
        <div className="home-back-button">
          <Link to="/login" className="back-button">
            ← {t('home.backToLogin')}
          </Link>
        </div>
        <div className="home-hero">
          <div className="home-hero-content">
            <h1 className="home-title">{t('home.title')}</h1>
            <p className="home-subtitle">{t('home.subtitle')}</p>
            <div className="home-cta-buttons">
              <Link to="/login" className="home-cta-primary">
                {t('home.primaryCta')}
              </Link>
              <Link to="/about" className="home-cta-secondary">
                {t('home.secondaryCta')}
              </Link>
            </div>
          </div>
          <div className="home-hero-image">
            <div className="home-image-placeholder">
              <span>{t('home.heroPreview')}</span>
            </div>
          </div>
        </div>

        <div className="home-features">
          <div className="home-features-header">
            <h2>{t('home.features.title')}</h2>
            <p>{t('home.features.subtitle')}</p>
          </div>
          
          <div className="home-features-grid">
            <div className="home-feature-card">
              <div className="home-feature-icon">⏰</div>
              <h3>{t('home.features.easyTimeTracking.title')}</h3>
              <p>{t('home.features.easyTimeTracking.description')}</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">💰</div>
              <h3>{t('home.features.expenseManagement.title')}</h3>
              <p>{t('home.features.expenseManagement.description')}</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">📊</div>
              <h3>{t('home.features.advancedReporting.title')}</h3>
              <p>{t('home.features.advancedReporting.description')}</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">🔒</div>
              <h3>{t('home.features.secureReliable.title')}</h3>
              <p>{t('home.features.secureReliable.description')}</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">📱</div>
              <h3>{t('home.features.mobileFriendly.title')}</h3>
              <p>{t('home.features.mobileFriendly.description')}</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">👥</div>
              <h3>{t('home.features.teamCollaboration.title')}</h3>
              <p>{t('home.features.teamCollaboration.description')}</p>
            </div>
          </div>
        </div>

        <div className="home-stats">
          <div className="home-stats-content">
            <div className="home-stat">
              <div className="home-stat-number">10,000+</div>
              <div className="home-stat-label">{t('home.stats.activeUsers')}</div>
            </div>
            <div className="home-stat">
              <div className="home-stat-number">500+</div>
              <div className="home-stat-label">{t('home.stats.companies')}</div>
            </div>
            <div className="home-stat">
              <div className="home-stat-number">99.9%</div>
              <div className="home-stat-label">{t('home.stats.uptime')}</div>
            </div>
            <div className="home-stat">
              <div className="home-stat-number">24/7</div>
              <div className="home-stat-label">{t('home.stats.support')}</div>
            </div>
          </div>
        </div>

        <div className="home-cta-section">
          <div className="home-cta-content">
            <h2>{t('home.cta.title')}</h2>
            <p>{t('home.cta.subtitle')}</p>
            <Link to="/login" className="home-cta-button">
              {t('home.cta.button')}
            </Link>
          </div>
        </div>
      </div>
      <Footer className="home-footer">{t('layout.footer')}</Footer>
    </>
  );
};

export default Home; 